import QuickActions from 'react-native-quick-actions' /* eslint-disable-line */
import Config from 'react-native-config'
import Device from '@config/device'

const scheme = Config.APP_SCHEME

const configure = () => {
  const shortcutItems = [
    {
      type: 'Nutritionist',
      title: 'Ask Nutritionist',
      icon: Device.ios ? 'Message' : 'message',
      userInfo: {
        url: `${scheme}://app/modals/newMessage`,
      },
    },
    {
      type: 'Activities',
      title: 'Log Activity',
      icon: Device.ios ? 'Compose' : 'note',
      userInfo: {
        url: `${scheme}://app/modals/newActivity`,
      },
    },
    {
      type: 'Meals',
      title: 'Log Meal',
      icon: Device.ios ? 'CapturePhoto' : 'food',
      userInfo: {
        url: `${scheme}://app/modals/newMeal`,
      },
    },
    {
      type: 'Sensor',
      title: 'Sensor',
      icon: Device.ios ? 'taskCompleted' : 'circle_dot_solid',
      userInfo: {
        url: `${scheme}://app/settings/sensor`,
      },
    },
  ]

  QuickActions.setShortcutItems(shortcutItems)
}

export default { configure }
